import { render, staticRenderFns } from "./channelFansDetails.vue?vue&type=template&id=3a28a772&scoped=true"
import script from "./channelFansDetails.vue?vue&type=script&lang=js"
export * from "./channelFansDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a28a772",
  null
  
)

export default component.exports